import { NgIf, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';

import { ConfigService } from '@dav-core/services/config.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe],
})
export class LoaderComponent {
  constructor(public configService: ConfigService) {}
}
